const apiAddress = "https://apibackend.puregrove.in";
//const apiAddress = "http://192.168.29.64:8000";
//const apiAddress = "https://backendapi.loya.solutions";
export default apiAddress;
